<template>
  <!-- 数据资源 左侧导航�?-->
  <div class="leftnav">
    <el-tooltip
      class="item"
      effect="dark" 
      placement="top" 
      :enterable="false"
      :content="isCollapse ? '开导航栏' : '收导航栏'"
      :open-delay="50" >
      <div class="colspan" @click="isCollapse = !isCollapse">
        <i class="el-icon-s-fold icon" v-show="!isCollapse"></i>
        <i class="el-icon-s-unfold icon" v-show="isCollapse"></i>
      </div>
    </el-tooltip>

    <div class="top">
      <div class="logo">
        <img class="logo-img"
        :class="{ 'logo-img-small': isCollapse }" 
        src="@/assets/imgs/left-nav-icon/logo2.png" />
      </div>
    </div>

    <div class="menu_box" :class="{ mini_menu_box: isCollapse }">
      <el-menu class="el-menu-vertical-demo" 
        ref="el_menu" 
        mode="vertical" 
        unique-opened
        :default-active="defaultActive"
        :collapse="isCollapse"
        @open="handleOpen">

        <fragment v-for="(item,index) in leftNavData" :key="item.index">
          <el-menu-item 
            class="one_menu_item"
            :index="item.index"
            :ref="'menu' + item.index" 
            @click="menuClick(item)"
            @mouseover.native="menuHover(item,index)"
            @mouseleave.native="menuLeave(item,index)" 
            v-if="item.isShow && !item.childe">
            <img class="img-icon" :src="item.icon" v-if="openMenu !== item.index && activeInd !== index" />
            <img class="img-icon" :src="item.iconed" v-if="openMenu === item.index || activeInd === index" />
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>

          <!-- 多级菜单 -->
          <el-submenu 
            :index="item.index"
            :ref="'submenu' + item.index"
            :key="item.index"
            @click="menuClick(item)" 
            v-if="item.isShow && item.childe">

            <template slot="title">
              <div class="title-icon"
                style="width: 100%" 
                :class="{ 't-i': isCollapse, 
                active:  openMenu === item.index}" 
                @mouseover="menuHover(item,index)"
                @mouseleave="menuLeave(item,index)">
                <img class="img-icon" :src="item.icon" v-if="openMenu !== item.index && activeInd !== index" />
                <img class="img-icon" :src="item.iconed" v-if="openMenu === item.index || activeInd === index" />
                <span slot="title">{{ item.name }}</span>
              </div>
            </template>

            <el-menu-item
              class="submenu_item"
              v-for="(item2,index2) in item.childe"
              :key="item2.index"
              :index="item2.index"
              @click="menuClick(item2)"
              v-if="item2.isShow">
              <span slot="title">{{ item2.name }}</span>
            </el-menu-item>
          </el-submenu>

        </fragment>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { leftNavData } from "./left-nav-data";
export default {
  name: "LeftNavBar",
  data() {
    return {
      isCollapse: false, //是否收起导航�?
      leftNavData: leftNavData,

      openMenu: 'Home',
      activeInd: 0,
      defaultActive: "Home",

      isHaveChild: false,

      active: false, // 为多级栏目设置的

      timer: null,
      flag: false
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    // 权限 登录的用户信�?
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  mounted() {
    this.verifyFilterColumn()

    this.timer = setTimeout(() => {
      this.isCollapse = true;
    }, 3000);
  },
  methods: {
    verifyFilterColumn(){
      // 根据权限显示左边菜单�?
      if(!this.userInfo.data.right) return
      let rightObj = this.userInfo.data.right;
      this.leftNavData.map(item => {
        if(item.childe && item.childe.length){
          item.childe.map(item2 => {
            item2.isShow = rightObj[item2.index]
          })
        }
        item.isShow = rightObj[item.index]
      })
    },
    handleOpen(key, keyPath) {
      console.log("handleOpen:>>>>", key, keyPath);

      let data = this.leftNavData.filter(item => item.index === key)[0]
      if(!data || !data.childe || !data.childe.length) return
      let index = data.childe.findIndex(item => item.index === this.defaultActive)
      let child = data.childe.filter(item => item.isShow)[index >= 0 ? index : 0]
      if(!child) return

      this.defaultActive = 'null'
      this.$nextTick(() => {
        this.defaultActive = child.index
        this.menuClick(child)
      })
    },
    //点击菜单
    menuClick(item) {
      // 点击之后不再收起侧栏
      if(!this.flag) this.flag = true
      this.timer && clearTimeout(this.timer) && (this.timer = null)
      
      console.log("menuClick:>>>>>>", item);
      
      if(item.isRouter){
        this.$router.push({ name: item.index });
      }else{
        this.$router.push({ 
          path: '/modelmanage/' + item.index + '/name_zn/' + item.name
        });
      }

      // if(item.index === "voiceguide_qrcode") {
      //   this.$router.back();
      //   return window.open("http://124.31.223.71:30036/#/EditingManagement", '_blank');
      // }
    },
    // 鼠标经过菜单
    menuHover(item,index) {
      this.activeInd = index
      this.timer && clearTimeout(this.timer) && (this.timer = null)
    },
    // 鼠标离开菜单
    menuLeave(item,index) {
      this.activeInd = null
      // 仅第一次并且未点击时重新计�?
      if(this.flag) return
      this.timer = setTimeout(() => {
        this.isCollapse = true;
        this.flag = true
      }, 3000);
    },
  },
  watch: {
    $route: {
      handler(newVal){
        this.openMenu = newVal.name === 'ModelManage' ? newVal.params.index : newVal.name
        this.defaultActive = newVal.params.index || newVal.name
        let index = this.leftNavData.findIndex(item => item.index === newVal.params.index || item.index === newVal.name)
        this.activeInd = index >= 0 ? index : null
        console.log('router:>>>>>>>>>>>>>>>>>',this.defaultActive,this.activeInd);
      },
      immediate: true
    },
    // 当宽度满足一定条件是进行相应的开或收导航�?
    windowWidth(nV, oV) {
      if (nV <= 1200 && this.isCollapse == false) {
        console.log("收导航栏");
        this.isCollapse = true;
      } else if (nV > 1200 && this.isCollapse == true) {
        console.log("开启导航栏");
        this.isCollapse = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.leftnav {
  z-index: 9999;
  position: relative;
  box-shadow: 3px 0px 66px 4px 
		rgba(199, 199, 199, 0.44);
}
.top {
  width: auto;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .logo {
    // height: 50px;
    width: 66px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    .logo-img {
      display: flex;
      // width: 64px;
      // height: 64px;
      width: 100%;
      height: 100%;
      transition: all 0.3s ease-in-out;
    }
  }
  .fontf {
    width: 134px;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    .font {
      width: 134px;
      min-width: 0;
    }
  }
}
.left-nav-title {
  font-family: "gz";
  width: 100%;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 24px;
  color: #fff;
  position: absolute;
  top: 0;
}
.left-nav-title span {
  font-family: "gz";
}
// 解决左侧导航条适应问题
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 160px;
  min-height: 400px;
  // min-width: 170px;
}
.el-menu-item i {
  color: #ffffff !important;
}
.menu_box {
  width: auto;
  height: calc(100vh - 100px);
  // overflow-y: auto;
  :deep(.el-menu){
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar{
      background-color: #fff;
    }
  }
}
.menu_box {
  -ms-overflow-style: none;
}
.el-menu {
  background-color: unset;
  overflow: hidden;
}
.el-menu-item.submenu_item {
  display: block !important;
}

.el-menu-item.submenu_item.is-active {
  // color: #fc7f5b;
  color: #3c51ec !important;
  // background-color: #fff1d7;
  background-color: #eef2ff;
  
  span {
    // border-bottom: 2px solid #fc7f5b;
    // border-bottom: 2px solid #3c51ec !important;
  }
}
.submenu_item span {
  // margin-left: 8px;
  display: inline-block;
  width: 56px;
  padding-bottom: 5px;
  text-align-last: justify;
}
:deep(.el-submenu__title) {
  height: 46px;
  line-height: 46px;
  padding: 0 0 0 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  // text-align: center;
  margin-top: 10px;
  position: relative;
}
.el-submenu .el-menu-item {
  padding-left: 32px !important;
  overflow: hidden;
}
.el-submenu__title span {
  color: #8c8c8c !important;
  font-size: 14px !important;
}
.el-submenu__title:hover span {
  // color: #fc7f5b !important;
  color: #3c51ec !important;
}
// .el-submenu__title:hover {
//   color: #e70f0f;
// }
.one_menu_item {
  margin-top: 10px;
  height: 46px;
  line-height: 46px;
  // padding: 0 20px 0 0px !important;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  transition: all 0.2s ease-in-out;
  font-size: 14px !important;
}
.one_menu_item span {
  font-size: 14px;
  // margin-top: -10px;
  // vertical-align: middle;
}

.one_menu_item.is-active {
  position: relative;
  // color: #fb6f49 !important;
  color: #3c51ec !important;
  // border-left: 3px solid #f08300;
  // background-color: #fff1d7 !important;
  background-color: #eef2ff;
  &::before{
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    width: 3px;
    height: 16px;
    margin-top: -8px;
    background-image: linear-gradient(0deg, #3c51ec 0%, #8a98ff 100%);
  }
}
.default_menu_item.is-active {
  color: #8c8c8c !important;
  border-left: 3px solid #f08300;
  background-color: #ffffff !important ;
}
.one_menu_item.el-menu-item:hover {
  // color: #fb6f49;
  color: #3c51ec !important;
  background-color: #fff !important;
}
.one_menu_item.el-menu-item {
  color: #8c8c8c;
}
.el-submenu.is-active {
  background-color: none !important;
}
.title-icon {
  width: 100%;
  // padding: 0 20px 0 0px;
}
:deep(.el-menu),
.el-menu--inline {
  background: none;
}
:deep(.el-menu-item),
.submenu_item {
  // text-align: center;
  color: #8c8c8c;
}
.el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  background-color: #fff;
}
.el-menu-item.submenu_item:hover {
  // color: #fb6f49;
  color: #3c51ec !important;
}
:deep(.el-menu-item):hover {
  color: #1b1f8e;
}
.el-menu-vertical-demo.el-menu .title-icon {
  padding: 0 20px 0 20px;
}
.el-menu-vertical-demo.el-menu .img-icon {
  // margin-right: 20px;
}
.el-menu-vertical-demo.el-menu--collapse.el-menu .title-icon {
  padding: 0 0 0 20px !important;
}
.el-menu-vertical-demo.el-menu--collapse.el-menu .img-icon {
  margin: 0;
  // width: 22px;
  width: 28px;
  height: 28px;
}
:deep(.one_menu_item) .el-tooltip {
  left: 20px !important;
  // text-align: center;
  // display: flex !important;
  // align-items: center;
  // justify-content: center;
}
.logo-img-small {
  transition: all 0.3s ease-in-out;
  height: 40px !important;
  width: 33px !important;
}
.font-small {
  width: 0px !important;
  transition: all 0.3s ease-in-out;
  // transform: scale(0.5);
  // display: none;
}
.img-icon {
  margin-right: 18px;
  // margin-top: 10px;
  // width: 22px;
  width: 28px;
  height: 28px;
}
.colspan {
  cursor: pointer;
  width: 30px;
  height: 28px;
  text-align: center;
  position: absolute;
  top: 14px;
  right: -50px;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    color: #797979;
    font-size: 30px;
  }
}
:deep(.el-tooltip) {
  padding: 0 !important;
}
.mini_menu_box {
}
.t-i {
  padding: 0 !important;
}
.active {
  background-color: #fff !important;
  border-bottom: 0px solid;
  border-left: 3px solid #f08300;
  span {
    color: #1b1f8e !important;
    // margin-right: 20px;
  }
}
.actived {
  background-color: #fff !important;
  border-bottom: 0px solid;
  border-left: 3px solid #f08300;
  span {
    color: #1b1f8e !important;
    // margin-right: 20px;
  }
}
:deep(.el-menu).el-menu--inline {
  background: rgba(243, 242, 242, 0.26);
  text-align: center;
}
:deep(.el-submenu__icon-arrow) {
  right: 12px;
  margin-top: -6px !important;
}

:deep(.el-menu--inline) {
  // height: 500px;
  // overflow-y: scroll;
  // overflow-x: hidden;
}
:deep(.el-menu--inline)::-webkit-scrollbar {
  width: 4px;
}
:deep(.el-menu--inline)::-webkit-scrollbar-corner {
  border-radius: 4px;
}
</style>

